import { render, staticRenderFns } from "./maximage.vue?vue&type=template&id=5ff110a7"
import script from "./maximage.vue?vue&type=script&lang=js"
export * from "./maximage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports